export type OnboardingExperienceKey = "generic" | "clinics" | "legal" | "psychology" | "real_estate";

type ActivitySuggestion = { value: string; aliases: readonly string[]; experienceKey: OnboardingExperienceKey };

// Local, editable suggestions only. They do not grant plans, modules, or facts.
export const businessActivitySuggestions: readonly ActivitySuggestion[] = [
  { value: "Barbearia", aliases: ["barbearia", "barbeiro"], experienceKey: "generic" },
  { value: "Salão de Beleza", aliases: ["salao", "beleza", "cabeleireiro"], experienceKey: "generic" },
  { value: "Clínica Médica", aliases: ["clinica medica", "consultorio medico", "medico"], experienceKey: "clinics" },
  { value: "Clínica Odontológica", aliases: ["odontologia", "dentista", "odontologica"], experienceKey: "clinics" },
  { value: "Psicologia", aliases: ["psicologia", "psicologo", "psicologa"], experienceKey: "psychology" },
  { value: "Fisioterapia", aliases: ["fisioterapia", "fisioterapeuta"], experienceKey: "clinics" },
  { value: "Nutrição", aliases: ["nutricao", "nutricionista"], experienceKey: "clinics" },
  { value: "Advocacia", aliases: ["advocacia", "advogado", "juridico", "juridica"], experienceKey: "legal" },
  { value: "Contabilidade", aliases: ["contabilidade", "contador", "contabil"], experienceKey: "generic" },
  { value: "Restaurante", aliases: ["restaurante", "comida", "gastronomia"], experienceKey: "generic" },
  { value: "Pizzaria", aliases: ["pizzaria", "pizza"], experienceKey: "generic" },
  { value: "Lanchonete", aliases: ["lanchonete", "lanche", "hamburgueria"], experienceKey: "generic" },
  { value: "Comércio", aliases: ["comercio", "varejo", "loja"], experienceKey: "generic" },
  { value: "Loja de Roupas", aliases: ["loja de roupas", "moda", "vestuario"], experienceKey: "generic" },
  { value: "Pet Shop", aliases: ["pet shop", "pet", "veterinaria"], experienceKey: "generic" },
  { value: "Academia", aliases: ["academia", "musculacao", "treino"], experienceKey: "generic" },
  { value: "Escola", aliases: ["escola", "colegio", "educacao"], experienceKey: "generic" },
  { value: "Cursos", aliases: ["curso", "cursos", "treinamento"], experienceKey: "generic" },
  { value: "Oficina Mecânica", aliases: ["oficina", "mecanica", "automotiva"], experienceKey: "generic" },
  { value: "Serviços de Limpeza", aliases: ["limpeza", "faxina", "higienizacao"], experienceKey: "generic" },
  { value: "Refrigeração", aliases: ["refrigeracao", "ar condicionado", "climatizacao"], experienceKey: "generic" },
  { value: "Engenharia", aliases: ["engenharia", "engenheiro"], experienceKey: "generic" },
  { value: "Arquitetura", aliases: ["arquitetura", "arquiteto"], experienceKey: "generic" },
  { value: "Informática", aliases: ["informatica", "tecnologia", "ti"], experienceKey: "generic" },
  { value: "Marketing", aliases: ["marketing", "publicidade", "agencia"], experienceKey: "generic" }
];

function normalized(value: string) {
  return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase("pt-BR").trim();
}

export function suggestedBusinessActivities(value: string, limit = 5) {
  const query = normalized(value);
  if (!query) return [];
  return businessActivitySuggestions.filter((item) => [item.value, ...item.aliases].some((term) => {
    const candidate = normalized(term);
    return candidate.includes(query) || query.includes(candidate);
  })).slice(0, limit);
}

export function inferredExperienceKey(value: string, fallback: OnboardingExperienceKey = "generic"): OnboardingExperienceKey {
  const query = normalized(value);
  if (!query) return fallback;
  const found = businessActivitySuggestions.find((item) => [item.value, ...item.aliases].some((term) => {
    const candidate = normalized(term);
    return query.includes(candidate) || candidate.includes(query);
  }));
  if (found) return found.experienceKey;
  if (/imobili|corretor|imovel/.test(query)) return "real_estate";
  return "generic";
}
